import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";
import { ArrowRight, ShieldCheck } from "lucide-react";

export default function RegistrationBanner() {
  return (
    <section data-testid="registration-banner" className="relative bg-nkf-blue text-white overflow-hidden">
      <div className="absolute inset-0 diagonal-stripes" />
      <div className="absolute -top-32 -right-32 w-[360px] h-[360px] sm:w-[420px] sm:h-[420px] rounded-full bg-nkf-gold/10 blur-3xl" />
      <div className="absolute -bottom-32 -left-32 w-[360px] h-[360px] sm:w-[420px] sm:h-[420px] rounded-full bg-nkf-red/10 blur-3xl" />

      <div className="nkf-container relative py-10 sm:py-14 md:py-20 lg:py-24 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/15 text-[10px] sm:text-xs uppercase tracking-[0.25em] sm:tracking-[0.3em] text-nkf-gold">
            <ShieldCheck className="h-3.5 w-3.5" /> Federation Notice
          </div>
          <h2
            data-testid="registration-headline"
            className="font-display mt-4 text-[2.4rem] leading-[1.05] sm:text-5xl md:text-6xl lg:text-7xl font-black tracking-wider text-nkf-gold"
            style={{ letterSpacing: "0.03em" }}
          >
            REGISTRATION
            <br />
            OPEN NOW
          </h2>
          <p className="mt-4 sm:mt-5 text-white/80 max-w-xl text-sm sm:text-base leading-relaxed">
            Membership &amp; Affiliation enrolment for the 2026–27 federation cycle is now active across all six categories. Register your Athlete, Coach, Referee, Academy, Club, or State Unit with the official national governing body.
          </p>
          <div className="mt-6 sm:mt-7 flex flex-wrap gap-3">
            <Link
              to="/register"
              data-testid="cta-register-now"
              className="inline-flex items-center gap-2 bg-nkf-gold text-nkf-navy font-bold px-5 sm:px-6 py-3 uppercase tracking-widest text-[12px] sm:text-sm hover:bg-white transition active:scale-[0.98]"
            >
              Register Now <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/memberships"
              data-testid="cta-view-categories"
              className="inline-flex items-center gap-2 border border-white/30 text-white px-5 sm:px-6 py-3 uppercase tracking-widest text-[12px] sm:text-sm hover:border-nkf-gold hover:text-nkf-gold transition"
            >
              View Categories
            </Link>
          </div>
          <div className="mt-6 sm:mt-8 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs sm:text-sm">
            <span className="text-nkf-gold font-semibold">Traditional Karate</span>
            <span className="text-white/30">|</span>
            <span className="text-white font-semibold">Semi Contact Karate</span>
            <span className="text-white/30">|</span>
            <span className="text-emerald-300 font-semibold">Full Contact Karate</span>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="rounded-md border border-white/10 bg-white/5 backdrop-blur-sm p-5 sm:p-6 shadow-xl">
            <div className="flex items-center justify-between gap-3">
              <div className="min-w-0">
                <div className="text-[10px] sm:text-[11px] uppercase tracking-[0.25em] sm:tracking-[0.3em] text-nkf-gold">Federation Statement</div>
                <div className="font-display text-xl sm:text-2xl md:text-3xl text-white mt-2 leading-tight">{BRAND.statement}</div>
              </div>
              <img src={BRAND.logo} alt="NKF" className="h-16 w-16 sm:h-20 sm:w-20 object-contain bg-white rounded-full p-1 shrink-0" />
            </div>
            <div className="mt-4 sm:mt-5 grid grid-cols-3 gap-2 sm:gap-3 text-center">
              {BRAND.slogan.map((s) => (
                <div key={s} className="hindi bg-nkf-gold/15 border border-nkf-gold/40 rounded px-1.5 sm:px-2 py-2.5 sm:py-3 text-nkf-gold text-sm sm:text-base font-semibold">
                  {s}
                </div>
              ))}
            </div>
            <div className="mt-4 sm:mt-5 text-[10px] sm:text-[11px] text-white/60 uppercase tracking-[0.2em] sm:tracking-[0.25em]">An initiative under the National Karate Federation – NKF Bharat</div>
          </div>
        </div>
      </div>
    </section>
  );
}
